import React, { useEffect, useState } from 'react'
// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import {
  Dialog,
  DialogTitle,
  DialogContent,
  Button,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Avatar,
} from "@mui/material";
import { Cancel as CancelIcon } from "@mui/icons-material";
import { orange } from "@mui/material/colors";
import { useDispatch, useSelector } from "react-redux";
import Swal from "sweetalert2";
import { CircularProgress } from "@mui/material";
import * as Yup from "yup";
import Autocomplete from "@mui/material/Autocomplete";
import { getCountries } from 'services/apis';
import { updateAdminProfile } from 'services/apis';
import profileDefault from "assets/images/Profile-default.jpg";
import { baseUrl } from 'services/axiosInstance';
import MDButton from 'components/MDButton';
import { getAdminDetail } from 'services/apis';
import { setAdminData } from '../../../redux/slices/adminDataSlice';
const EditModal = ({ isEditUserDialogOpen, setIsEditUserDialogOpen }) => {

  const dispatch = useDispatch()
  const user = useSelector((state) => state.adminData.adminData);
  // console.log('user: ', user,user.name);
  const formFields = [
    { name: "name", label: "Full Name", type: "text", maxLength: 25 },
    { name: "email", label: "Email", type: "email" },
    { name: "mobile", label: "Mobile", type: "text", maxLength: 10, pattern: "[0-9]*" },
    { name: "DOB", label: "Date of Birth", type: "date" },
  ];

  const [country, setCountry] = useState([])
  const [imagePreview, setImagePreview] = useState(null);
  const [buttonLoading, setButtonLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({
    name: "",
    email: "",
    mobile: "",
    DOB: "",
  });

  const formSchema = Yup.object().shape({
    name: Yup.string().required("Name is required"),
    email: Yup.string()
      .test("email", "Enter a valid Email", (value) => {
        if (!value) return false;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(value);
      })
      .required("Email is required"),
    mobile: Yup.string()
      .matches(/^[0-9]{10}$/, "Invalid mobile number")
      .required("Mobile number is required"),
    DOB: Yup.date().required("Date of birth is required"),
    gender: Yup.string().optional(),
  });

  const getInitialFormState = (user) => ({
    name: user?.name || "",
    email: user?.email || "",
    mobile: user?.mobile || "",
    DOB: user?.DOB || "",
    gender: user?.gender || "",
    country: user?.country || "",
    profilePic: null
  });

  const [editForm, setEditForm] = useState(getInitialFormState(user));
  useEffect(() => {
    setEditForm(getInitialFormState(user));
  }, [user]);

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await getCountries();
        setCountry(response.data);
      } catch (error) {
        console.error("Failed to fetch countries:", error);
      }
    };

    if (!country?.length && isEditUserDialogOpen) {
      fetchCountries();
    }
  }, [isEditUserDialogOpen]);

  const handleEditClose = () => {
    setIsEditUserDialogOpen(false);
    setEditForm(getInitialFormState(user));
    setFormErrors({
      name: "",
      email: "",
      mobile: "",
      DOB: "",
      gender: "",
      country: "",
    });
    setImagePreview(null);
  };
  const handleEditFormSubmit = async (event) => {
    event.preventDefault();
    setButtonLoading(true);
    const newFormData = new FormData();

    for (const key in editForm) {
      if (key in user) {
        if (
          editForm[key] !== "" &&
          editForm[key] !== user[key] &&
          editForm[key] !== null &&
          key !== "profilePic"
        ) {
          newFormData.append(key, editForm[key]);
        }
      }
    }
    if (editForm.profilePic !== null) {
      newFormData.append("profilePic", editForm.profilePic);
    }
    newFormData.append("userId", user.userId);


    try {
      const updateResponse = await updateAdminProfile(newFormData)
      console.log('newFormData: ', editForm);
      setButtonLoading(false);
      handleEditClose();
      Swal.fire({
        title: "Profile Updated!",
        icon: "success",
        timer: 1500,
        showConfirmButton: false,
      });

      // const adminResponse = await axiosInstance.post(
      //   "/getAdminDetails",
      //   {
      //     admin_id: user.user_id,
      //   }
      // );

      const adminResponse = await getAdminDetail({
        "email": user.email
      })
      console.log('adminResponse: ', adminResponse);
      dispatch(setAdminData(adminResponse.data))

    } catch (e) {
      Swal.fire({
        title: "Error Occurred!",
        icon: "error",
      });
      console.log(e.message);
      setButtonLoading(false);
      handleEditClose();
    }

  };

  const handleEditChange = (e) => {
    const { name, value } = e.target;

    setEditForm((prev) => ({
      ...prev,
      [name]: value,
    }));

    // Validate on change
    try {
      formSchema.validateSyncAt(name, { ...editForm, [name]: value });
      setFormErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    } catch (error) {
      setFormErrors((prev) => ({
        ...prev,
        [name]: error.message,
      }));
    }
  };

  const handleCountryEdit = (event, newValue) => {
    setEditForm({
      ...editForm,
      country: newValue ? newValue : "",
    });
  };

  const handleFileInputEdit = (event) => {
    const file = event.target.files[0];
    setEditForm({ ...editForm, profilePic: file });
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setImagePreview(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  const handleAutoComplete = (fieldName, valueName) => {
    return fieldName?.find((item) => item === valueName) || null;
  };

  return (
    <Dialog open={isEditUserDialogOpen} onClose={handleEditClose} maxWidth="sm" fullWidth>
      <DialogTitle>
        Edit Profile
        <span
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: "10px",
            cursor: "pointer",
          }}
        >
          <CancelIcon
            sx={{ color: orange[500] }}
            onClick={handleEditClose}
          />
        </span>
        <MDBox display="flex" justifyContent="center">
          <Avatar
            src={
              imagePreview ||
              (user?.userProfiles?.length ? baseUrl + user.userProfiles[0].image : profileDefault)
            }
            alt="profile-image"
            sx={{ height: "140px", width: "140px" }}
            shadow="sm"
          />
        </MDBox>
      </DialogTitle>
      <DialogContent sx={{ overflowX: "hidden" }}>
        <form onSubmit={handleEditFormSubmit}>
          <label
            htmlFor="profilePic"
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              border: "1px solid #ccc",
              padding: "2px",
              marginTop: "11px",
              marginBottom: "4px",
              borderRadius: "5px",
            }}
          >
            <input
              type="file"
              id="profilePic"
              accept="image/*"
              onChange={handleFileInputEdit}
              style={{ display: "none" }}
            />
            <Button component="span" color="primary" fullWidth>
              Edit Profile Image
            </Button>
            <span
              style={{
                textAlign: "center",
                width: "100%",
                marginTop: "1px",
              }}
            >
              {editForm.profilePic?.name}
            </span>
          </label>

          {formFields.map(({ name, label, type, maxLength, pattern }) => (
            <TextField
              key={name}
              margin="dense"
              fullWidth
              name={name}
              value={editForm[name]}
              onChange={handleEditChange}
              label={label}
              type={type}
              inputProps={{ maxLength, pattern }}
              error={!!formErrors[name]}
              helperText={formErrors[name]}
              {...(name === "DOB" && { InputLabelProps: { shrink: true } })}
            />
          ))}
          <FormControl
            fullWidth
            sx={{ marginTop: "7px", marginBottom: "4px" }}
          >
            <InputLabel id="gender1">Gender</InputLabel>
            <Select
              labelId="gender1"
              id="gender"
              value={editForm.gender}
              label="Gender"
              name="gender"
              onChange={handleEditChange}
              sx={{ height: "40px" }}
            >
              <MenuItem value="Male">Male</MenuItem>
              <MenuItem value="Female">Female</MenuItem>
              <MenuItem value="Other">Other</MenuItem>
            </Select>
          </FormControl>

          <Autocomplete
            sx={{ marginTop: "6.5px", marginBottom: "2px" }}
            id="country-select-demo"
            options={country}
            fullWidth
            autoHighlight
            getOptionLabel={(option) => option}
            onChange={handleCountryEdit}
            value={handleAutoComplete(
              country,
              editForm.country
            )}
            clearOnBlur
            disableClearable
            renderOption={(props, option) => {
              const { key, ...optionProps } = props;
              return (
                <MDBox
                  key={key}
                  component="li"
                  sx={{ "& > img": { mr: 2, flexShrink: 0 } }}
                  {...optionProps}
                >
                  {option}
                </MDBox>
              );
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Select a Country"
                inputProps={{
                  ...params.inputProps,
                  autoComplete: "new-password",
                }}
              />
            )}
          />

          <MDButton
            type="submit"
            fullWidth
            variant="gradient" color="light"
            size="small"
            disabled={buttonLoading || Object.values(formErrors).some((err) => err)}
            sx={{ marginTop: "7px" }}
          >
            {buttonLoading ? (
              <MDBox
                display="flex"
                justifyContent="center"
                alignItems="center"
                width="100%"
              >
                <CircularProgress
                  sx={{ color: "#ffffff" }}
                  size={24}
                />
              </MDBox>
            ) : (
              <MDTypography
                style={{ fontSize: "13.5px", fontWeight: "bold" }}
                color="white"
              >
                Submit
              </MDTypography>
            )}
          </MDButton>
        </form>
      </DialogContent>
    </Dialog>
  )
}

export default EditModal